import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { BasicHeatmapChartService } from './basic-heatmap-chart.service';
import { ActivityReportChartItem } from '../../../pages/activity-reports/models/activity-reports.models';

@Component({
    selector: 'app-basic-heatmap-chart',
    imports: [MatCardModule],
    templateUrl: './basic-heatmap-chart.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './basic-heatmap-chart.component.scss'
})
export class BasicHeatmapChartComponent {
    @Input() items: ActivityReportChartItem[] = [];

    constructor(private basicHeatmapChartService: BasicHeatmapChartService) {}

    ngAfterViewInit(): void {
        if (this.items && this.items.length > 0) {
            this.basicHeatmapChartService.loadChart(this.items);
        }
    }

    ngOnDestroy(): void {
        this.basicHeatmapChartService.destroyChart();
    }
}
